import { Button, Checkbox, Flex, Modal, notification, Tooltip } from "antd";
import ExpandableButton from "components/Common/Button/ExpandableButton";
import { SvgIcons } from "Icon/SvgIcons";
import React, { useEffect, useState } from "react";
import StickyBox from "react-sticky-box";
import CSVDownloader from "../ExtraActions/ExportCSV";
import SelectTalentPool from "components/Select/SelectTalentPool";
import { addCandidateToRole } from "api/project.api";
import { rejectCandidateFromJob } from "api/talentpool.api";
import { toggleProjectDetailRefresh } from "store/slices/talentPool";
import { useDispatch, useSelector } from "react-redux";
import CandidateModal from "components/Common/Candidate Actions/AddToTalentPool";
import { useRejectCandidates } from "utils";
import { useNavigate } from "react-router-dom";
import {
  replaceReduxCandidates,
  setBulkMailTalentPool,
} from "store/slices/candidateBulkMail.slice";
import { SmartRecruiter } from "../ExtraActions/SmartRecruter";
import { useAppSelector } from "hooks/reduxHooks";
import { useFeatureAllowedFromState, useIsOldFlow } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import { TeamOutlined } from "@ant-design/icons";
import { readUser } from "services/localStorage.service";
import { HubspotATS } from "../ExtraActions/HubspotATS";
import { createReport } from "api/reportTemplates.api";
import GenerateReportModal from "./GenerateReportModal";
import { reportEnabledEmails } from "utils/utils";

interface ButtonCandidateIO {
  selectedCandidates?: number[];
  selectedPool?: number | null;
  type?: "select" | "reject" | "import" | "suggest";
  isSearch?: boolean;
  isTalentPool?: boolean;
  allCandidates?: number;
  handleSelectAllCandidates?: () => void;
  unselectAllCandidates?: () => void;
  allCandidatesDetail?: any;
  allIdsSelected?: boolean;
  totalCandidates?: number;
  searchId?: number;
  refreshResult?: any;
  allIds?: any;
  projectName?: string;
}

const BottomCandidateSelect: React.FC<ButtonCandidateIO> = ({
  selectedCandidates,
  type = "suggest",
  unselectAllCandidates,
  handleSelectAllCandidates,
  selectedPool,
  isSearch = false,
  isTalentPool = false,
  allCandidates = 0,
  allCandidatesDetail = [],
  allIdsSelected,
  totalCandidates,
  searchId,
  refreshResult,
  allIds,
  projectName,
}) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [openGenerateReport, setOpenGenerateReport] = useState(false);
  const [generateReportLoading, setGenerateReportLoading] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedTalentedPool, setSelectedTalentedPool] = useState<number | null>(null);
  const [isAddToProject, setIsAddToProject] = useState(false);
  const dispatch = useDispatch();
  const selectedBulkMailCandidates =
    useSelector((state: any) => state.candidateBulkMail.candidates) || [];
  const userData = useAppSelector((state) => state.auth.user);
  const isBulkMailAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCBE);
  const user: any = useAppSelector((state) => state.user.user);
  const getUserInfo = readUser();
  const showModal = (addToProject: boolean) => {
    setIsAddToProject(addToProject);
    setIsModalVisible(true);
  };
  const isOldSearchFlow = useIsOldFlow();

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSelectChange = (value: number) => {
    setSelectedTalentedPool(value);
  };

  const handleReportGeneration = async () => {
    try {
      setGenerateReportLoading(true);

      const candidatesIds = allIdsSelected ? allIds : selectedCandidates;
      const payload = {
        name: projectName ?? "No Name",
        job: selectedPool ?? 0,
        candidate_ids: candidatesIds,
        report_format: "slides",
      };
      if (allIdsSelected) {
        delete payload.candidate_ids;
      }

      const response = await createReport(payload);
      navigate(`/report-editor/?reportId=${response?.id}`);
    } catch (error: any) {
      if (error?.errorFields) return; // form validation error
      notification.error({
        message: "Error",
        description: error?.message || "An error occurred while creating the report.",
      });
    } finally {
      setGenerateReportLoading(false);
    }
  };

  const buttonItems: any = [
    {
      icon: <span className="text-white">{SvgIcons.fileIcon}</span>,
      text: "Generate Report",
      loading: generateReportLoading,
      onClick: () => selectedPool && handleReportGeneration(),
      disabled:
        selectedBulkMailCandidates.length === 0 ||
        type !== "select" ||
        isTalentPool ||
        isOldSearchFlow,
    },
    {
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.99999 4.16699V15.8337M4.16666 10.0003H15.8333"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),

      text: "Add to Project",
      onClick: () => showModal(true),
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M1.66663 5.83301L8.47073 10.5959C9.0217 10.9816 9.29719 11.1744 9.59685 11.2491C9.86154 11.3151 10.1384 11.3151 10.4031 11.2491C10.7027 11.1744 10.9782 10.9816 11.5292 10.5959L18.3333 5.83301M5.66663 16.6663H14.3333C15.7334 16.6663 16.4335 16.6663 16.9683 16.3939C17.4387 16.1542 17.8211 15.7717 18.0608 15.3013C18.3333 14.7665 18.3333 14.0665 18.3333 12.6663V7.33301C18.3333 5.93288 18.3333 5.23281 18.0608 4.69803C17.8211 4.22763 17.4387 3.84517 16.9683 3.60549C16.4335 3.33301 15.7334 3.33301 14.3333 3.33301H5.66663C4.26649 3.33301 3.56643 3.33301 3.03165 3.60549C2.56124 3.84517 2.17879 4.22763 1.93911 4.69803C1.66663 5.23281 1.66663 5.93288 1.66663 7.33301V12.6663C1.66663 14.0665 1.66663 14.7665 1.93911 15.3013C2.17879 15.7717 2.56124 16.1542 3.03165 16.3939C3.56643 16.6663 4.26649 16.6663 5.66663 16.6663Z"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      text: "Send Bulk Email",
      onClick: () => {
        navigate(`/mail/bulk-mail/${selectedPool}`);
      },
      disabled: selectedBulkMailCandidates.length === 0 || type !== "select",
      isFeatureAllowed: isBulkMailAllowed,
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_443_30235)">
            <path
              d="M1.66663 9.99997L9.70182 14.0176C9.81114 14.0722 9.86579 14.0996 9.92313 14.1103C9.97391 14.1198 10.026 14.1198 10.0768 14.1103C10.1341 14.0996 10.1888 14.0722 10.2981 14.0176L18.3333 9.99997M1.66663 14.1666L9.70182 18.1842C9.81114 18.2389 9.86579 18.2662 9.92313 18.277C9.97391 18.2865 10.026 18.2865 10.0768 18.277C10.1341 18.2662 10.1888 18.2389 10.2981 18.1842L18.3333 14.1666M1.66663 5.83331L9.70182 1.81571C9.81114 1.76105 9.86579 1.73372 9.92313 1.72297C9.97391 1.71344 10.026 1.71344 10.0768 1.72297C10.1341 1.73372 10.1888 1.76105 10.2981 1.81571L18.3333 5.83331L10.2981 9.8509C10.1888 9.90556 10.1341 9.93289 10.0768 9.94365C10.026 9.95317 9.97391 9.95317 9.92313 9.94365C9.86579 9.93289 9.81114 9.90556 9.70182 9.8509L1.66663 5.83331Z"
              stroke="white"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_443_30235">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      text: "Move to Talent Pool",
      onClick: () => showModal(false),
    },
    // {
    //   icon: (
    //     <TeamOutlined twoToneColor="#fffff" style={{ color: "white" }} />
    //   ),
    //   disabled: (user.id === 133 || user.id === 308 || user.id === 227),
    //   text: "ATS Export",
    // },
  ];

  const handleAddCandidate = async () => {
    const payload = {
      jobs: [selectedTalentedPool],
      candidates: selectedCandidates,
      is_shortlisted: true,
    };
    setLoading(true);
    try {
      const data = await addCandidateToRole(payload);
      notification.success({
        message: "Success",
        description: isAddToProject
          ? "Candidate successfully added to the project."
          : "Candidate successfully moved to the talent pool.",
      });
      setIsModalVisible(false);
    } catch (error) {
      notification.error({
        message: "Error",
        description: isAddToProject
          ? "Failed to add candidate to the project."
          : "Failed to move candidate to the talent pool.",
      });
    } finally {
      setLoading(false);
    }
  };

  const HandleMove = () => {
    handleAddCandidate();
  };

  const { rejectCandidates, loadingReject, error, success } = useRejectCandidates();

  const handleRejectCandidates = async () => {
    if (selectedPool && selectedCandidates) {
      const candidatesIds = allIdsSelected ? allIds : selectedCandidates;
      await rejectCandidates({ selectedPool, selectedCandidates: candidatesIds });
      if (error) {
        console.error("Error:", error.message);
      }
      if (allIdsSelected) {
        refreshResult && refreshResult();
      }
      if (success) {
        setIsModalVisible(false);
      }
    }
  };

  useEffect(() => {
    if (allCandidatesDetail.length > 0 && selectedCandidates) {
      const selectedCandidatesDetails = allCandidatesDetail.filter((candidate: any) =>
        selectedCandidates.includes(candidate.id)
      );

      const selectedCandidatesForBulkMail = selectedCandidatesDetails
        .filter((candidate: any) => candidate.full_name && candidate.email)
        .map((candidate: any) => ({
          id: candidate.id,
          name: candidate.full_name,
          email: candidate.emails,
          profile: candidate.profile_image_url,
          location: candidate.location,
          jobTitle: candidate.titles,
          graphProfileId: candidate.graph_profile_id,
        }));
      if (selectedCandidatesForBulkMail.length > 0 && selectedPool) {
        dispatch(replaceReduxCandidates(selectedCandidatesForBulkMail));
        dispatch(setBulkMailTalentPool(selectedPool));
      }
    }
  }, [allCandidatesDetail, selectedCandidates]);

  // useEffect(() => {
  //   if (unselectAllCandidates && allCandidatesDetail.length === 0) {
  //     unselectAllCandidates();
  //   }
  // }, [allCandidatesDetail]);

  if (
    selectedCandidates?.length === 0 ||
    !selectedCandidates ||
    getUserInfo.role === "EXTERNAL_CONTRIBUTOR"
  ) {
    return null;
  }

  const isGreenHouse = userData?.plugins?.some(
    (plugin: any) => plugin.name === "Greenhouse-Mckinney"
  );
  const isSmartRecruiter = userData?.plugins?.some(
    (plugin: any) => plugin.name === "SmartRecruiter"
  );
  const isLever = userData?.plugins?.some((plugin: any) => plugin.name === "Lever-SS");
  const isHubSpot = userData?.plugins?.some((plugin: any) => plugin.name === "Hubspot-Sinecure");

  return (
    <>
      <StickyBox offsetBottom={0} style={{ position: "sticky", bottom: 17, zIndex: 10 }}>
        <Flex className="bg-primary rounded-xl shadow-lg gap-2 mx-6 py-2 px-6">
          <Flex align="center" className="flex-grow">
            <Checkbox
              className="custom-checkbox"
              onChange={handleSelectAllCandidates}
              checked={allCandidates === selectedCandidates.length}
              style={
                {
                  "--checkbox-bg": "white",
                  "--checkbox-check-color": "var(--primary-color)",
                } as React.CSSProperties
              }
            >
              <span className="text-white">
                {allIdsSelected ? totalCandidates : selectedCandidates?.length} selected
              </span>
            </Checkbox>
            <span onClick={handleSelectAllCandidates}>{SvgIcons.crossArrow}</span>
          </Flex>
          <Flex align="center" justify="space-between" gap={86}>
            <Flex align="center" gap={18}>
              {buttonItems.map((item: any, index: any) =>
                item.disabled ? null : (
                  <ExpandableButton
                    key={index}
                    loading={item?.loading}
                    icon={item.icon}
                    text={item.text}
                    onClick={item.onClick}
                    disabled={item.isFeatureAllowed ? !item.isFeatureAllowed : false}
                  />
                )
              )}
              {!isSearch && (
                <>
                  <CSVDownloader
                    roleId={selectedPool}
                    type={type}
                    candidates={allIdsSelected ? null : selectedCandidates}
                    title={type}
                  ></CSVDownloader>

                  {type === "select" && (
                    <>
                      {isSmartRecruiter && (
                        <SmartRecruiter
                          roleId={selectedPool}
                          allIdsSelected={allIdsSelected}
                          selectedCandidateList={
                            allIdsSelected ? [...allIds] : [...selectedCandidates]
                          }
                        ></SmartRecruiter>
                      )}
                      {isGreenHouse && (
                        <SmartRecruiter
                          title="Greenhouse"
                          roleId={selectedPool}
                          allIdsSelected={allIdsSelected}
                          selectedCandidateList={
                            allIdsSelected ? [...allIds] : [...selectedCandidates]
                          }
                        ></SmartRecruiter>
                      )}
                      {isLever && (
                        <SmartRecruiter
                          title="Lever"
                          allIdsSelected={allIdsSelected}
                          roleId={selectedPool}
                          selectedCandidateList={
                            allIdsSelected ? [...allIds] : [...selectedCandidates]
                          }
                        ></SmartRecruiter>
                      )}
                      {isHubSpot && (
                        <HubspotATS
                          roleId={selectedPool}
                          allIdsSelected={allIdsSelected}
                          selectedCandidateList={
                            allIdsSelected ? [...allIds] : [...selectedCandidates]
                          }
                        ></HubspotATS>
                      )}
                    </>
                  )}
                  {!isSearch && type != "reject" && (
                    <ExpandableButton
                      icon={
                        <svg
                          width={20}
                          height={20}
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5"
                            stroke="#ffff"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      }
                      loading={loadingReject}
                      text="Delete"
                      onClick={handleRejectCandidates}
                    />
                  )}
                </>
              )}
            </Flex>
            <ExpandableButton
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M15 5L5 15M5 5L15 15"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              text="Close"
              onClick={unselectAllCandidates}
            />
          </Flex>
        </Flex>
      </StickyBox>
      {isModalVisible && (
        <CandidateModal
          isVisible={isModalVisible}
          onClose={handleCancel}
          selectedCandidates={selectedCandidates || []}
          selectedPool={selectedPool}
          isAddToProject={isAddToProject}
          allIdsSelected={allIdsSelected}
          isSearch={isSearch}
          type={type}
          searchId={searchId}
        />
      )}
      {/* {selectedPool &&
        <GenerateReportModal
          open={openGenerateReport}
          setOpen={setOpenGenerateReport}
          selectedPool={selectedPool}
          allIdsSelected={allIdsSelected}
          allIds={allIds}
          selectedCandidates={selectedCandidates}
        />} */}
    </>
  );
};

export default BottomCandidateSelect;
